import { apiGet, apiPost, apiPut } from './api';

// Premium Exams (Phase 02) client. All calls live under the versioned Premium
// namespace; a 404 means the module is off and the caller must render nothing.

const P = '/premium/v1';

export const examModuleStatus = () =>
  apiGet(`${P}/exams/module/status`).catch(() => ({ module_enabled: false, entitled: false }));

export const fetchExams = (status = 'active', studentId = '') =>
  apiGet(`${P}/exams?status=${status}${studentId ? `&student_id=${encodeURIComponent(studentId)}` : ''}`);
export const fetchExamStudents = () => apiGet(`${P}/exams/students`);
export const fetchCurriculum = (board = '', classLevel = '') =>
  apiGet(`${P}/academic/curriculum?board=${encodeURIComponent(board)}&class_level=${encodeURIComponent(classLevel)}`);

export const createExam = (payload) => apiPost(`${P}/exams`, payload);
export const updateExam = (id, payload) => apiPut(`${P}/exams/${id}`, payload);
export const setExamSubjects = (id, payload) => apiPut(`${P}/exams/${id}/subjects`, payload);
export const updatePortion = (id, payload) => apiPut(`${P}/exams/${id}/portion`, payload);
export const archiveExam = (id) => apiPost(`${P}/exams/${id}/archive`, {});
export const restoreExam = (id) => apiPost(`${P}/exams/${id}/restore`, {});
export const duplicateExam = (id, payload) => apiPost(`${P}/exams/${id}/duplicate`, payload);
export const adoptExam = (payload) => apiPost(`${P}/exams/adopt`, payload);

// Day-by-day plan (Today's Mission maths). Generating replaces the plan but
// keeps whatever the child has already finished.
export const generatePlan = (examId) => apiPost(`${P}/exams/${examId}/plan`, {});
export const fetchPlan = (examId) => apiGet(`${P}/exams/${examId}/plan`);

// Exam Mode gate — may Exam Mode start, and on which chapter? The server
// answers with either a single blocking issue or the chapter the plan wants.
export const fetchExamModeReadiness = () => apiGet(`${P}/exam-mode/readiness`);

// Phase 04 — review a shared blueprint BEFORE adopting; nothing is copied here.
export const previewSharedExam = (code, childId = '') =>
  apiGet(`${P}/exams/shared/${encodeURIComponent(code)}${childId ? `?child_id=${encodeURIComponent(childId)}` : ''}`);
export const fetchOverrides = (id) => apiGet(`${P}/exams/${id}/overrides`);
export const saveOverrides = (id, payload) => apiPut(`${P}/exams/${id}/overrides`, payload);
export const revertOverrides = (id, subject = '') =>
  apiPost(`${P}/exams/${id}/overrides/revert${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`, {});

export const ASSESSMENT_TYPES = [
  { key: 'unit_test', label: 'Unit Test' },
  { key: 'term_exam', label: 'Term Exam' },
  { key: 'half_yearly', label: 'Half-Yearly' },
  { key: 'annual', label: 'Annual' },
  { key: 'other', label: 'Other Assessment' },
];
